import { render, staticRenderFns } from "./ProductEditComponent.vue?vue&type=template&id=4410fac6"
import script from "./ProductEditComponent.vue?vue&type=script&lang=js"
export * from "./ProductEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductEditComponent.vue?vue&type=style&index=0&id=4410fac6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports